import ApiService from "@/common/api/api.service";

const ContratoLicencaService = {
    contratoLicenca : function(form) {
        if(!form.id)
            return ApiService.post("/contratoLicenca/contrato-licenca", form);
        return ApiService.put("/contratoLicenca/contrato-licenca", form);
    },

    removerLicenca : function(id) {
        return ApiService.delete("/contratoLicenca/contrato-licenca/", {id});
    },

    parcela : function(form) {
        if(!form.id)
            return ApiService.post("/contratoLicenca/parcela", form);
        return ApiService.put("/contratoLicenca/parcela", form);
    },

    removerParcela : function(id) {
        return ApiService.delete("/contratoLicenca/parcela/", {id});
    },

    buscarContrato : function(id) {
        return ApiService.get(`/contratoLicenca/${id}`);
    },

    listarContratos : function(filtro) {
        return ApiService.get(`/contratoLicenca/?empresaId=${filtro.empresaId}${filtro.visualizar == 'somenteVigencia' ? '&somenteVigencia=true' : ''}${filtro.visualizar == 'somenteEncerrados' ? '&somenteEncerrados=true' : ''}`);
    },

    downloadContrato:function(id)
    {
        return ApiService.downloadFile(`/contratoLicenca/contrato-licenca/download?id=${id}`);
    },

    downloadArquivoParcela:function(id, isComprovante)
    {
        return ApiService.downloadFile(`/contratoLicenca/parcela/download?id=${id}&isComprovante=${isComprovante}`);
    }
};

export default ContratoLicencaService;
